export const SET_LOADING_DATA = '@accessProfile/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@accessProfile/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@accessProfile/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@accessProfile/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@accessProfile/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@accessProfile/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@accessProfile/SAVE_REQUEST';
export const SAVE_SUCCESS = '@accessProfile/SAVE_SUCCESS';

export const DELETE_ITEM = '@accessProfile/DELETE_ITEM';
export const EDIT_ITEM = '@accessProfile/EDIT_ITEM';

export const SEARCH = '@accessProfile/SEARCH';

export const SET_PAGE = '@accessProfile/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@accessProfile/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@accessProfile/SET_ORDER';
export const SET_ORDERBY = '@accessProfile/SET_ORDEBY';
